// @ts-nocheck e3c9a6b1
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_audioplayer'],
      sections: [
        addPanel.sections.getSections().music.singleTrackPlayerSection2,
      ],
    };
  },
};
